export default {"src":"/_next/static/media/fx-private-relay-logotype-dark.aecd4e2d.svg","height":48,"width":307,"blurWidth":0,"blurHeight":0};